<template>
  <div class="sales-info-card">
    <!-- 销售信息 -->
    <div class="section">
      <div v-if="salesInfo.length > 0" class="section-title">
        <div class="title-bar"></div>
        <h3>销售</h3>
      </div>
      <div class="section-content flex-layout">
        <div v-for="(item, index) in salesInfo" :key="index" class="info-item">
          <div class="icon-container">
            <div class="icon" :class="item.type"></div>
          </div>
          <div class="info-text">{{ item.text }}</div>
        </div>
      </div>
    </div>

    <div v-if="salesManagerName.length > 0 || salesManager.length > 0" class="divider"></div>

    <!-- 销售负责人 -->
    <div class="section">
      <div v-if="salesManagerName.length > 0 || salesManager.length > 0" class="section-title">
        <div class="title-bar"></div>
        <h3>销售负责人
          <span v-for="item in salesManagerName" class="name">（{{ item }}） </span>
        </h3>
      </div>
      <div class="section-content flex-layout">
        <div v-for="(item, index) in salesManager" :key="index" class="info-item">
          <div class="icon-container">
            <div class="icon" :class="item.type"></div>
          </div>
          <div class="info-text">{{ item.text }}</div>
        </div>
      </div>
    </div>

    <div v-if="salesManagers.length > 0" class="divider"></div>

    <!-- 销售经理 -->
    <div class="section">
      <div v-if="salesManagers.length > 0" class="section-title">
        <div class="title-bar"></div>
        <h3>销售经理</h3>
      </div>
      <div class="section-content">
        <div class="managers-grid">
          <div
            v-for="(manager, index) in salesManagers"
            :key="index"
            class="manager-item"
          >
            <div class="manager-name">{{ manager.name }}</div>
            <div class="manager-contact">
              <div class="contact-item">
                <div class="icon phone"></div>
                <div class="contact-text">{{ manager.phone }}</div>
              </div>
              <div class="contact-item">
                <div class="icon email"></div>
                <div class="contact-text">{{ manager.email }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  salesInfo: {
    type: Array,
    required: true
  },
  salesManager: {
    type: Array,
    required: true
  },
  salesManagers: {
    type: Array,
    required: true
  },
  salesManagerName: {
    type: Array,
    required: true
  }
})
</script>

<style scoped>
.sales-info-card {
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 20px;
  transition: box-shadow 0.3s ease;
  margin-bottom: 40px;
}

.section {
  margin-bottom: 20px;
}

.section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.title-bar {
  width: 4px;
  height: 16px;
  background-color: #0055A2;
  margin-right: 10px;
}

.section-title h3 {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  span{
    color: #333;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
}

/* 销售信息布局 */
.flex-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.flex-layout .info-item {
  display: flex;
  align-items: center;
  flex: 1 0 auto;
  min-width: 200px;
}

.info-item {
  display: flex;
  align-items: flex-start;
}

.icon-container {
  display: flex;
  align-items: center;
}

.icon {
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 16px;
}

.icon.phone {
  background-image: url("@/assets/phone.png");
  width: 13px;
  height: 13px;
}

.icon.fax {
  background-image: url("@/assets/fax.png");
  width: 13px;
  height: 13px;}

.icon.email {
  background-image: url("@/assets/email.png");
  width: 13px;
  height: 13px;
}

.icon.wechat {
  background-image: url("@/assets/wechat.png");
  width: 13px;
  height: 13px;
}

.info-text {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

/* 分隔线 */
.divider {
  height: 1px;
  background-color: #eee;
  margin: 20px 0;
}

/* 销售经理网格 */
.managers-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

.manager-item {
  background-color: #f5f7fa;
  padding: 15px;
}

.manager-name {
  color: #333;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 10px;
}

.manager-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
}

.contact-text {
  color: #666;
  font-size: 13px;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .managers-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .sales-info-card {
    padding: 15px;
  }

  .flex-layout .info-item {
    min-width: 150px;
  }

  .managers-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .divider {
    margin: 15px 0;
  }
}

@media (max-width: 480px) {
  .sales-info-card {
    padding: 12px;
  }

  .flex-layout {
    flex-direction: column;
    gap: 12px;
  }

  .flex-layout .info-item {
    min-width: 100%;
  }

  .managers-grid {
    grid-template-columns: 1fr;
  }

  .section-title h3 {
    font-size: 15px;
  }

  .info-text {
    font-size: 13px;
  }

  .manager-name {
    font-size: 14px;
  }

  .contact-text {
    font-size: 12px;
  }

  .divider {
    margin: 12px 0;
  }
}
</style>